// extracted by mini-css-extract-plugin
export default {"container":"FloatingActionMenuItem_container__tHCa-","linkTitle":"FloatingActionMenuItem_linkTitle__RYZXX"};